import styled, { css } from 'styled-components'

import { Label } from '@nx/fire/typography'

export const ExpandableArea = styled.div<{
  $isExpanded: boolean
  $cutOffHeight: number
  $contentHeight: number
  $contentIsLarger: boolean
}>`
  ${({ $isExpanded, $cutOffHeight, $contentHeight, $contentIsLarger }) => css`
    height: ${$isExpanded
      ? $contentHeight === 0
        ? 'auto'
        : `${$contentHeight}px`
      : $contentIsLarger
        ? `${$cutOffHeight}px`
        : 'auto'};
    overflow: hidden;
    position: relative;
    transition: height ease 0.3s;
  `}
`

export const FadeOut = styled.div<{
  $fadeOutColour?: string
  $showFade: boolean
}>`
  ${({ theme, $fadeOutColour, $showFade }) => css`
    bottom: 0;
    left: 0;
    max-height: ${$showFade ? '110px' : 0};
    right: 0;
    position: absolute;
    transition: opacity ease 0.3s;

    ${theme.helpers.fadeOut(
      $fadeOutColour ? $fadeOutColour : theme.colours.primary.white
    )}
  `}
`

export const ReadMoreButton = styled(Label)`
  background: none;
  border: 0;
  color: ${({ theme }) => theme.colours.primary.primary};
  cursor: pointer;
  margin-top: 15px;
  padding: 0;
`
